import { mediumDownBreakPoint } from "../util/helpers.js"

const mainNavButton = document.querySelector(".burger-button"),
  primaryNav = document.querySelector(".primary-navigation")

function mainNavigationToggle(mediumDownBreakPoint) {
  if (mediumDownBreakPoint.matches) {
    if (mainNavButton) {
      mainNavButton.addEventListener("click", (event) => {
        event.preventDefault()

        mainNavButton.classList.toggle("is-active")
        primaryNav.classList.toggle("is-expanded")
        document.body.classList.toggle("js-no-scroll")
      })
    }
  }
}

window.addEventListener("load", () => {
  mainNavigationToggle(mediumDownBreakPoint)
})
